import { MESSAGE } from '@/constants'

export const responses = {
  [MESSAGE.RESPONSE_CODE.E_DEFAULT]: 'Siamo spiacenti, si è verificato un errore',
  [MESSAGE.RESPONSE_CODE.E_INVALID_BECH32_ADDRESS]: 'Spiacente ma l\'indirizzo non è in un formato valido. Si prega di controllare',
  [MESSAGE.RESPONSE_CODE.E_WALLET_NOT_EXISTS]: 'Errore nell\'indirizzo del wallet',
  [MESSAGE.RESPONSE_CODE.OK_DEFAULT]: 'Successo',
}